import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/inject-solar/dashboard/shared.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private ResponseVerifiedLogin$: Subject<any> = new Subject();
  loginObj: { login_id: any; password: any; };
  public message: string;
  public role: any;
  public token: any;
  public id: any;
  public is_emeter:any;
  public is_wms:any;
  public emp_id: any;
  public password: any;
  public name: any;
  login_id: string;
  public logo:any;
  company_name: string;
  SadminAccess: any=[];
  public showPassword:boolean;
  // resultObject : any = {};

  constructor(private authService: AuthService, private router: Router, private toastr: ToastrService) {
  }

  ngOnInit() {
  }


  onLogin(frm) {
    this.loginObj = {
      login_id: frm.value.login_id,
      password: frm.value.password
    };
    this.authService.login(this.loginObj)
      .pipe(takeUntil(this.ResponseVerifiedLogin$))
      .subscribe(
        data => {
          if (data.status) {
            localStorage.clear();
            this.toastr.success(data.message);
            this.token = data.resultObject.token;
            this.role = data.resultObject.role;
            this.id = data.resultObject.id;
            this.name = data.resultObject.name;
            this.login_id = data.resultObject.login_id;
            this.logo = data.resultObject.logo;
            this.company_name =data.resultObject.company_name;
            this.SadminAccess = data.resultObject.SadminAccess ;
            this.is_emeter = data.resultObject.is_emeter;
            this.is_wms = data.resultObject.is_wms;
            localStorage.setItem('loginToken', this.token);
            localStorage.setItem('role', this.role);
            localStorage.setItem('name', this.name);
            localStorage.setItem('id', this.id);
            localStorage.setItem('login_id', this.login_id);
            localStorage.setItem('logo', this.logo);
            localStorage.setItem('company_name', this.company_name);
            localStorage.setItem('SadminAccess', JSON.stringify(this.SadminAccess) || '[]');
            localStorage.setItem('is_emeter', this.is_emeter);
            localStorage.setItem('is_wms', this.is_wms);

            // this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]')
            this.router.navigate(['/inject-solar/dashboard/']);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  togglePassword(){
    this.showPassword = !this.showPassword;
  }
  ngOnDestroy() {
    this.ResponseVerifiedLogin$.next();
    this.ResponseVerifiedLogin$.complete();
  }
}
